import { useQuery } from "@tanstack/react-query";
import { getAfventendeIndberetninger } from "@/api/efteruddannelse";
import type { AfventendeIndberetningModel } from "@/interfaces/afventendeIndberetning";

export const AFVENTENDE_INDBERETNINGER_QUERY_KEY = [
  "efteruddannelse",
  "afventende-indberetninger",
] as const;

export const useAfventendeIndberetninger = () =>
  useQuery<AfventendeIndberetningModel[]>({
    queryKey: AFVENTENDE_INDBERETNINGER_QUERY_KEY,
    queryFn: getAfventendeIndberetninger,
    staleTime: 5 * 60 * 1000,
  });
